import type { BackendRouteDefinition } from '../types';

export const createFirmOnboardingFormsRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/onboarding/forms',
  body: (requestData) => requestData,
} as const satisfies BackendRouteDefinition;
